import { Insights, Store } from "../types/insights";
import api from "./api";

export const listInsights = async (): Promise<Insights[]> => {
  const response = await api.get(
    "insights-p2-:stage/:stage/crm/prospeccao/getListaProspeccao"
  );
  return response.data;
};

// getClienteTotalizadores
export const listCustomerTotalizers = async (obj: object | null) => {
  const response = await api.get(
    "insights-p1-:stage/:stage/crm/perfil/totalizadores",
    {
      params: { ...obj },
    }
  );

  return response.data[0];
};

// getContadorCelularQtde
export const listCellTotalizers = async (obj: object | null) => {
  const response = await api.get(
    "https://api.datasales.info/sms-p1-:stage/:stage/crm/getContadorCelularQtde",
    {
      params: { ...obj },
    }
  );

  return response.data.valor_total;
};

// getContadorEmailQtde
export const listEmailTotalizers = async (obj: object | null) => {
  const response = await api.get(
    "https://api.datasales.info/email-p1-:stage/:stage/crm/getContadorEmailQtde",
    {
      params: { ...obj },
    }
  );

  return response.data.valor_total;
};

// getTotalCadastros
export const listTotalRegistrations = async (obj: object | null) => {
  const response = await api.get(
    "https://api.datasales.info/insights-p1-:stage/:stage/crm/perfil/total",
    {
      params: { ...obj },
    }
  );

  return response.data.total;
};

// getOverviewDDD
export const listOverviewDDD = async (obj: object | null) => {
  const response = await api.get(
    "https://api.datasales.info/insights-p1-:stage/:stage/crm/overview/ddd",
    {
      params: { ...obj },
    }
  );

  return response.data;
};

// getOverviewGenre
export const listOverviewGenre = async (obj: object | null) => {
  const response = await api.get(
    "https://api.datasales.info/insights-p1-:stage/:stage/crm/overview/genre",
    {
      params: { ...obj },
    }
  );

  return response.data;
};

// getOverviewRegisterDay
export const listOverviewRegisterDay = async (obj: object | null) => {
  const response = await api.get(
    "https://api.datasales.info/insights-p1-:stage/:stage/crm/overview/register-day",
    {
      params: { ...obj },
    }
  );

  return response.data;
};

// getOverviewRegisterMonth
export const listOverviewRegisterMonth = async (obj: object | null) => {
  const response = await api.get(
    "https://api.datasales.info/insights-p1-:stage/:stage/crm/overview/register-month",
    {
      params: { ...obj },
    }
  );

  return response.data;
};

// getOverviewAge
export const listOverviewAge = async (obj: object | null) => {
  const response = await api.get(
    "https://api.datasales.info/insights-p1-:stage/:stage/crm/overview/age",
    {
      params: { ...obj },
    }
  );

  return response.data;
};

// listaLojas
export const listStores = async (): Promise<Store[]> => {
  const response = await api.get("/config-p1-:stage/:stage/crm/getLojas");

  return response.data;
};

// getListaFiltro
export const getProspectList = async () => {
  const response = await api.get(
    "https://api.datasales.info/insights-p2-:stage/:stage/crm/prospeccao/getListaProspeccao" // mudar pra :stage
  );

  return response.data;
};

// listaTodasProfissao
export const listAllProfession = async (obj?: object | null) => {
  const response = await api.get(
    "https://api.datasales.info/insights-p1-:stage/:stage/crm/todas/profissao",
    {
      params: { ...obj },
    }
  );

  return response.data;
};

// listaProdutos
export const listAllProducts = async (obj: object | null) => {
  const response = await api.get(
    "https://api.datasales.info/insights-p1-:stage/:stage/crm/perfil/produtos",
    {
      params: { ...obj },
    }
  );

  return response.data;
};

// getListaCategoria1
export const listAllCategories1 = async (obj?: object | null) => {
  const response = await api.get(
    "https://api.datasales.info/insights-p3-:stage/:stage/crm/insights/getInsightsCategoria1",
    {
      params: { ...obj },
    }
  );

  return response.data;
};

// getListaCategoria2
export const listAllCategories2 = async (obj?: object | null) => {
  const response = await api.get(
    "https://api.datasales.info/insights-p3-:stage/:stage/crm/insights/getInsightsCategoria2",
    {
      params: { ...obj },
    }
  );

  return response.data;
};

// getListaCategoria3
export const listAllCategories3 = async (obj?: object | null) => {
  const response = await api.get(
    "https://api.datasales.info/insights-p3-:stage/:stage/crm/insights/getInsightsCategoria3",
    {
      params: { ...obj },
    }
  );

  return response.data;
};

// getListaCategoria4
export const listAllCategories4 = async (obj?: object | null) => {
  const response = await api.get(
    "https://api.datasales.info/insights-p3-:stage/:stage/crm/insights/getInsightsCategoria4",
    {
      params: { ...obj },
    }
  );

  return response.data;
};

// getListaCategoria5
export const listAllCategories5 = async (obj?: object | null) => {
  const response = await api.get(
    "https://api.datasales.info/insights-p3-:stage/:stage/crm/insights/getInsightsCategoria5",
    {
      params: { ...obj },
    }
  );

  return response.data;
};

// getListaCategoria6
export const listAllCategories6 = async (obj?: object | null) => {
  const response = await api.get(
    "https://api.datasales.info/insights-p3-:stage/:stage/crm/insights/getInsightsCategoria6",
    {
      params: { ...obj },
    }
  );

  return response.data;
};

// getListaCategoria7
export const listAllCategories7 = async (obj?: object | null) => {
  const response = await api.get(
    "https://api.datasales.info/insights-p3-:stage/:stage/crm/insights/getInsightsCategoria7",
    {
      params: { ...obj },
    }
  );

  return response.data;
};

// getListaCategoria8
export const listAllCategories8 = async (obj?: object | null) => {
  const response = await api.get(
    "https://api.datasales.info/insights-p3-:stage/:stage/crm/insights/getInsightsCategoria8",
    {
      params: { ...obj },
    }
  );

  return response.data;
};

// getListaCategoria9
export const listAllCategories9 = async (obj?: object | null) => {
  const response = await api.get(
    "https://api.datasales.info/insights-p3-:stage/:stage/crm/insights/getInsightsCategoria9",
    {
      params: { ...obj },
    }
  );

  return response.data;
};

// getListaCategoria10
export const listAllCategories10 = async (obj?: object | null) => {
  const response = await api.get(
    "https://api.datasales.info/insights-p3-:stage/:stage/crm/insights/getInsightsCategoria10",
    {
      params: { ...obj },
    }
  );

  return response.data;
};

// getListaCategoria11
export const listAllCategories11 = async (obj: object | null) => {
  const response = await api.get(
    "https://api.datasales.info/insights-p3-:stage/:stage/crm/insights/getInsightsCategoria11",
    {
      params: { ...obj },
    }
  );

  return response.data;
};

// getListaCategoria12
export const listAllCategories12 = async (obj: object | null) => {
  const response = await api.get(
    "https://api.datasales.info/insights-p3-:stage/:stage/crm/insights/getInsightsCategoria12",
    {
      params: { ...obj },
    }
  );

  return response.data;
};

export const listConsumptionProfile = async () => {
  const response = await api.get(
    "/insights-p3-:stage/:stage/crm/insights/getConsumptionProfile"
  );

  return response.data;
};

// getTagOrigem
export const listTagOrigin = async (obj?: object | null) => {
  const response = await api.get(
    "https://api.datasales.info/insights-p3-:stage/:stage/crm/getTagOrigem",
    {
      params: { ...obj },
    }
  );

  return response.data;
};

// getClusterAudiencia
export const listAudienceCluster = async (obj?: object | null) => {
  const response = await api.get(
    "https://api.datasales.info/cluster-p1-:stage/:stage/crm/cluster/getClusterAudiencia",
    {
      params: { ...obj },
    }
  );

  return response.data;
};

// getClienteMapa
export const listClientMap = async (obj?: object | null) => {
  console.log(obj);
  const response = await api.get(
    "https://api.datasales.info/insights-p1-:stage/:stage/crm/perfil/mapa",
    {
      params: { ...obj },
    }
  );

  return response.data;
};

// getClienteTotal
export const listTotalClients = async (obj?: object | null) => {
  const total = await api.get(
    "https://api.datasales.info/insights-p1-:stage/:stage/crm/perfil/total",
    {
      params: { ...obj },
    }
  );

  const listaCliente = await api.get(
    "https://api.datasales.info/insights-p3-:stage/:stage/crm/perfil/getListaClientes",
    {
      params: { ...obj },
    }
  );

  const naoCliente = await api.get(
    "https://api.datasales.info/insights-p3-:stage/:stage/crm/perfil/getNaoClientes",
    {
      params: { ...obj },
    }
  );

  const response = {
    total: total.data.total,
    n_compraram: naoCliente.data,
    clientes: listaCliente.data,
  };

  return { response, total: response.clientes };
};

// getClienteSexo
export const listClientSex = async (obj: object | null) => {
  const response = await api.get(
    "https://api.datasales.info/insights-p1-:stage/:stage/crm/perfil/sexo",
    {
      params: { ...obj },
    }
  );

  return response.data;
};

// getClienteStatus
export const listClientStatus = async (obj: object | null) => {
  const response = await api.get(
    "https://api.datasales.info/insights-p1-:stage/:stage/crm/perfil/status",
    {
      params: { ...obj },
    }
  );

  return response.data;
};

// getClienteTermometro
export const listClientThermometer = async (obj: object | null) => {
  const response = await api.get(
    "https://api.datasales.info/insights-p1-:stage/:stage/crm/perfil/termometro",
    {
      params: { ...obj },
    }
  );

  return response.data;
};

// getClienteIdade
export const listClientAge = async (obj: object | null) => {
  const response = await api.get(
    "https://api.datasales.info/insights-p1-:stage/:stage/crm/perfil/idade",
    {
      params: { ...obj },
    }
  );

  return response.data;
};

// getClienteProfissao
export const listClientProfession = async (obj: object | null) => {
  const response = await api.get(
    "https://api.datasales.info/insights-p1-:stage/:stage/crm/perfil/profissao",
    {
      params: { ...obj },
    }
  );

  return response.data;
};

// saveListProspecsPF
export const saveListProspecsPF = async ({
  objParameters,
  filtroSegmentacao,
}): Promise<any> => {
  const response = await api.post(
    "insights-p2-:stage/:stage/crm/prospeccao/saveProspeccao",
    { objParameters, filtroSegmentacao }
  );

  const data = response.data;

  if (data.nova_lista) {
    const payload = {
      dataFilter: data.nova_lista.data_filtro,
      filtro: data.nova_lista.filtro,
      filtro_completo: data.nova_lista.filtro_completo,
      idListProspectei: data.nova_lista.id_prospeccao_lista,
      nameList: data.nova_lista.nome_lista,
    };

    return payload;
  } else {
    return false;
  }
};

// postClusterAudiencia
export const saveClusterAudience = async (cluster): Promise<any> => {
  const response = await api.post(
    "cluster-p1-:stage/:stage/crm/cluster/postClusterAudiencia",
    { cluster }
  );

  return response.data;
};

// excluirFiltro
export const deleteAudience = async (idList): Promise<any> => {
  const response = await api.delete(
    "insights-p2-:stage/:stage/crm/prospeccao/deleteListaProspeccao",
    {
      data: { idList },
    }
  );

  return response.data;
};

// updateListProspecsPF
export const updateListProspecsPF = async ({
  objParameters,
  filtroSegmentacao,
}): Promise<any> => {
  const response = await api.put(
    "insights-p2-:stage/:stage/crm/prospeccao/updateProspeccao",
    { objParameters, filtroSegmentacao }
  );

  const data = response.data;

  if (data.nova_lista) {
    const payload = {
      dataFilter: data.nova_lista.data_filtro,
      filtro: data.nova_lista.filtro,
      filtro_completo: data.nova_lista.filtro_completo,
      idListProspectei: data.nova_lista.id_prospeccao_lista,
      nameList: data.nova_lista.nome_lista,
    };

    return payload;
  } else {
    return false;
  }
};

//putNotShowProspeccao
export const updateNotShow = async (idList: number, not_show: number) => {
  const response = await api.put("insights-p2-dev/dev/crm/prospeccao/notShow", {
    idList,
    not_show,
  });
  return response.data;
};

// getReprocessoAudiencia
export const listReprocessAudience = async (id_prospeccao: number) => {
  const response = await api.get(
    "insights-p3-:stage/:stage/crm/getReprocessoAudiencia",
    {
      params: { id_prospeccao },
    }
  );

  return response.data;
};

// getReprocessoAudienciaSaida
export const listReprocessAudienceOut = async (id_prospeccao: number) => {
  const response = await api.get(
    "insights-p3-:stage/:stage/crm/getReprocessoAudienciaSaida",
    {
      params: { id_prospeccao },
    }
  );

  return response.data;
};

// getReprocessoAudienciaEntrada
export const listReprocessAudienceIn = async (id_prospeccao: number) => {
  const response = await api.get(
    "insights-p3-:stage/:stage/crm/getReprocessoAudienciaEntrada",
    {
      params: { id_prospeccao },
    }
  );

  return response.data;
};

// postReprocessaAudiencia
export const saveReprocessAudience = async (reprocessa): Promise<any> => {
  const response = await api.post(
    "insights-p3-:stage/:stage/crm/postReprocessaAudiencia",
    reprocessa
  );

  return response.data;
};

// putReprocessaAudiencia
export const updateReprocessAudience = async (reprocessa): Promise<any> => {
  const response = await api.put(
    "insights-p3-:stage/:stage/crm/putReprocessaAudiencia",
    reprocessa
  );

  return response.data;
};

// getListaFiltroCSV
export const listProfilesCSV = async (idListProspectei): Promise<any> => {
  const response = await api.post(
    "insights-p2-:stage/:stage/crm/prospeccao/getCSVProspeccao",
    { idListProspectei }
  );

  return response.data;
};

// getAllDocumentos
export const listAllDocuments = async (partDocumento: any) => {
  const tempDoc = Boolean(partDocumento)
    ? partDocumento.replace(/\D+/g, "")
    : false;
  if (Boolean(tempDoc) && tempDoc.length >= 3) {
    const part = { partDocumento: tempDoc };
    const response = await api.get(
      "insights-p3-:stage/:stage/crm/getDocumentos",
      {
        params: part,
      }
    );
    return response.data;
  }

  return [];
};
